import { createFileRoute } from "@tanstack/react-router";

import EtimsConnectionPage from "@/features/dashboard/pages/etims-connection";

export const Route = createFileRoute("/(app)/ops/connections/etims")({
  component: () => <EtimsConnectionPage />,
});
